import type { HTMLAttributes, ReactNode } from 'react';
import React from 'react';
import classNames from 'classnames';
import type { ImageDetails } from '$cms/index';
import type { CmsImage } from '$cms/types';
import { Img } from '../../../src/components/atoms/Img';

import styles from './index.module.scss';

export interface AllianzInsuredProps extends HTMLAttributes<HTMLDivElement> {
  readonly image: ImageDetails | CmsImage;
  readonly width?: number;
  readonly height?: number;
  readonly children: ReactNode;
}

export function AllianzInsured({
  className,
  image,
  width,
  height,
  children,
  ...props
}: AllianzInsuredProps): JSX.Element {
  return (
    <aside className={classNames(className, styles.AllianzInsured)} {...props}>
      <span>{children}</span>
      <Img
        provider="cloudinary"
        src={image.url}
        alt={image.alt}
        title={image.title}
        layout="fixed"
        width={width || image.width}
        height={height || image.height}
      />
    </aside>
  );
}
AllianzInsured.displayName = 'AllianzInsured';
